import { PageTemplate } from '@/shared/ui/templates';
import { Sidebar } from '../components/sidebar';
import { BuyerDetails } from '../components/buyer-details';
import { Col, Row, notification } from 'antd';
import { useEffect, useState } from 'react';
import { AddBuyerModal } from '../components/add-buyer-modal';
import { AddOfferModal } from '../../common/components/add-offer-modal/index.component';
import styles from './index.module.sass';
import {
  $buyersData,
  $singleBuyerData,
  fetchBuyersListFx,
  setActiveBuyer,
} from '../store/buyers.store';
import { BuyerInstance } from '../ts';
import { useSearchParams } from 'react-router-dom';
import { useStore } from 'effector-react';
import { EmptyMain } from '../components/empty-main';
import { handleSubmit } from '../functions/handle-submit.function';
import { useWindowDimensions } from '@/modules/common/hooks/use-window-dimensions.hook';
import classNames from 'classnames';
import {
  $buyersListSortState,
  setBuyersListOrder,
  setBuyersListSortOption,
  setBuyersListSortSearchString,
} from '../store/sort.store';

export const SellerAccountPage = () => {
  const [showBuyerModal, setShowBuyerModal] = useState(false);
  const [showOfferModal, setShowOfferModal] = useState(false);
  // const [sortOption, setSortOption] = useState([
  //   { label: 'алфавиту', val: 'company_name', active: true },
  //   // { label: 'расстоянию от вас', val: 'distance', active: false },
  //   { label: 'типу контрагента', val: 'type', active: false },
  // ]);
  // const [orderBy, setOrderBy] = useState<'asc' | 'desc'>('asc');
  const [_, setSearchParams] = useSearchParams();
  const [offersModalViible, setOffersModalVisible] = useState(false);
  const { width } = useWindowDimensions();
  const [sidebarVisible, setSidebarVisible] = useState(true);
  const buyersData = useStore($buyersData);
  const singleBuyerData = useStore($singleBuyerData);

  const sortState = useStore($buyersListSortState);

  const handleSubmitWithParams = (dto: BuyerInstance) => {
    return handleSubmit(
      dto,
      sortState.options,
      sortState.orderBy,
      sortState.searchString,
      setSearchParams,
      setShowBuyerModal,
    );
  };

  useEffect(() => {
    (async () => {
      await fetchBuyersListFx({
        sortBy: sortState.options.find((item) => item.active)?.val,
        orderBy: sortState.orderBy,
        search: sortState.searchString,
      });
    })();
  }, [sortState.searchString]);

  // useEffect(() => {
  //   console.log(buyersData);
  //   if (buyersData?.data) {
  //     fetchBuyerByIdFx({id: buyersData?.data[0].id, md5: buyersData?.data[0].type === 'external' ? md5(buyersData?.data[0].label) : undefined})
  //   }//fetchBuyerOffersListFx()
  // }, [buyersData])

  const refetchBuyersList = async () =>
    await fetchBuyersListFx({
      sortBy: sortState.options.find((item) => item.active)?.val,
      orderBy: sortState.orderBy,
      search: sortState.searchString,
    });
  const searchActiveBuyer = buyersData?.data?.find(
    (item) => item.id === singleBuyerData?.id,
  );

  const selectedBuyer = searchActiveBuyer?.id ?? buyersData?.data[0].id;
  setActiveBuyer(selectedBuyer);
  return (
    <PageTemplate
      header="покупатели"
      customAction={{
        label: 'добавить нового покупателя',
        action: () => setShowBuyerModal(true),
      }}
      customBackAction={width <= 1280 ? () => setSidebarVisible(true) : undefined}
      customBack="/mixing"
      className={styles.root}
    >
      <Row gutter={16} style={{ height: '100%' }}>
        <Col
          lg={10}
          xl={8}
          xxl={6}
          className={classNames(styles.sidebar, !sidebarVisible && styles.hidden)}
        >
          <Sidebar
            sortOption={sortState.options}
            setSortOption={setBuyersListSortOption}
            setOrderBy={setBuyersListOrder}
            orderBy={sortState.orderBy}
            searchString={sortState.searchString}
            setSearchString={setBuyersListSortSearchString}
            setOffersModalVisible={setOffersModalVisible}
            setShowBuyerModal={setShowBuyerModal}
            onSelectBuyer={() => setSidebarVisible(false)}
          />
        </Col>
        <Col
          lg={14}
          xl={16}
          xxl={18}
          className={classNames(styles.contentArea, sidebarVisible && styles.hidden)}
        >
          {selectedBuyer ? (
            <BuyerDetails
              orderBy={sortState.orderBy}
              sortOption={sortState.options}
              setSortOption={setBuyersListSortOption}
              setShowOfferModal={setShowOfferModal}
              showOfferModal={showOfferModal}
              searchString={sortState.searchString}
              setSearchString={setBuyersListSortSearchString}
              refetchBuyersList={refetchBuyersList}
              searchActiveBuyer={searchActiveBuyer}
            />
          ) : (
            <EmptyMain />
          )}
        </Col>
      </Row>

      <>
        <AddBuyerModal
          visible={showBuyerModal}
          closeFn={() => setShowBuyerModal(false)}
          handleSubmit={handleSubmitWithParams}
        />
        {/* <OffersListModal
          visible={offersModalViible}
          setVisible={setOffersModalVisible}
        /> */}
        {showOfferModal && (
          <AddOfferModal
            visible={showOfferModal}
            closeFn={() => setShowOfferModal(false)}
            refetchBuyersList={refetchBuyersList}
          />
        )}
      </>
    </PageTemplate>
  );
};
